export const SecuritySeverity = {
  None: 'none',
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Critical: 'critical',
} as const

export type SecuritySeverity = (typeof SecuritySeverity)[keyof typeof SecuritySeverity]
